module.exports = __webpack_public_path__ + "static/img/AIGC视频-产品视频.1f5cd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC视频-产品视频.png
// module id = oRfT
// module chunks = 1